import { Box, Skeleton, Stack } from '@mui/material';

/** Reserves the overview layout until household and setup data are ready. */
export function HouseholdSetupSkeleton() {
  return (
    <Stack role="status" aria-label="Loading household" spacing={3}>
      <Skeleton
        variant="rectangular"
        animation={false}
        sx={{ height: { xs: 260, md: 320 } }}
      />
      <Stack spacing={1} aria-hidden sx={{ px: 2 }}>
        <Skeleton animation={false} width="40%" height={28} />
        <Skeleton animation={false} width="55%" height={20} />
      </Stack>
      <Box
        aria-hidden
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, minmax(0, 1fr))',
            lg: 'repeat(4, minmax(0, 1fr))',
          },
          gap: 2,
          px: 2,
        }}
      >
        {['memo', 'model', 'summary', 'insights'].map((card) => (
          <Skeleton
            key={card}
            variant="rounded"
            animation={false}
            height={300}
          />
        ))}
      </Box>
    </Stack>
  );
}
